import React, { useCallback, useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { Button, ButtonGroup, Col, Form, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { BsArrowDown } from "react-icons/bs";
import { FaSearch } from "react-icons/fa";
import { RiFilterLine, RiFilterOffLine } from "react-icons/ri";
import * as Yup from "yup";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import TextSpinner from "../../../../components/UI/Spinner/TextSpinner";
import TextInputFormik from "../../../../components/UI/TextInput/TextInputFormik";
import SelectInputCachedFormik from "../../../../components/UI/SelectInput/SelectInputCachedFormik";
import HtmlToString from "../../../../components/Formatters/HtmlToString";
import ListaExecutoresAssociadosOs from "./ListaExecutoresAssociadosOs";
import ListaExecutoresAssociadosInclusao from "./ListaExecutoresAssociadosInclusao";
import ListaExecutoresAssociadosExclusao from "./ListaExecutoresAssociadosExclusao";
import constants from "../../../Constants";

const columns = [
  {
    name: "Setor",
    selector: (row) => row.siglaOrgao,
    center: true,
    sortable: true,
  },
  {
    name: "Nome",
    selector: (row) => row.nomeFormal,
    width: "30%",
    sortable: true,
  },
  {
    name: "Matrícula",
    selector: (row) => row.matricula,
    center: true,
  },
  {
    name: "Qtd Ações",
    selector: (row) => row.quantidadeOs,
    width: "12%",
    center: true,
    sortable: true,
  },
  {
    name: "Tipos de Ação Fiscal",
    cell: (row) =>
      row.quantidadeTipoAf ? (
        <span>
          <HtmlToString html={row.quantidadeTipoAf} />
        </span>
      ) : (
        ""
      ),
    width: "33%",
    center: true,
  },
];

const validationSchema = Yup.object().shape({
  sequencialOrgao: Yup.string().default(""),
  nomeFormal: Yup.string().default(""),
});

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  initialValues[key] = "";
});

const ListaAlteracaoExecutor = ({
  formik: propsFormik,
  field,
  sqAltExec,
  acaoFiscal,
  alteracaoExecutor,
  ehAlteracaoExecutor,
  sqAltExecOs,
  quantidadeIncluidosOs,
  quantidadeExcluidosOs,
  quantidadeTotalExecutores,
  fgLimpar,
  fgLimparOs,
}) => {
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchParameters, setSearchParameters] = useState({});
  const [inputSearchArgument, setInputSearchArgument] = useState("");
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  const [associadoExcluido, setAssociadoExcluido] = useState("");
  const [sqAlteracaoExecutor, setSqAlteracaoExecutor] = useState(0);

  const associadoOsExcluido = (excluido) => {
    if (excluido !== undefined) {
      setAssociadoExcluido(excluido);
    }
  };

  const sqAlteracaoExecutorOs = (novo) => {
    if (novo !== undefined) {
      setSqAlteracaoExecutor(novo);
      sqAltExecOs(novo);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
  });

  const updateFormik = (state) => {
    propsFormik.setFieldValue(field, state.selectedRows);
  };

  const handlePageChange = useCallback((newPageNumber) => {
    setPageNumber(newPageNumber);
  }, []);

  const handlePerRowsChange = useCallback((newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(1);
  }, []);

  const { request: requestConsulta, data: dataConsulta, errors: errorConsulta, isLoading } = useApiClient();

  useEffect(() => {
    if (sqAltExec !== 0) {
      setSqAlteracaoExecutor(sqAltExec);
    }
  }, [sqAltExec]);

  useEffect(() => {
    requestConsulta(apiRoutes.fiscalizacao.ordemservico.consultaExecutores, {
      ...searchParameters,
      pageSize,
      pageNumber,
    });
  }, [requestConsulta, searchParameters, pageSize, pageNumber]);

  useEffect(() => {
    if (dataConsulta && dataConsulta.result) {
      if (dataConsulta.result.length && !dataConsulta.result[0].totalRows) {
        console.error(`[DEV] A propriedade "totalRows" é obrigatória nos resultados paginados.`);
        return;
      }
      quantidadeTotalExecutores(dataConsulta.result.length ? dataConsulta.result[0].totalRows : 0);
      setRows(dataConsulta.result || []);
      setTotalRows(dataConsulta.result.length ? dataConsulta.result[0].totalRows : 0);
    }

    if (errorConsulta) {
      toast.error(errorConsulta.message);
    }
  }, [dataConsulta, errorConsulta, quantidadeTotalExecutores]);

  return (
    <>
      {" "}
      <div className="row">
        <ListaExecutoresAssociadosOs
          acaoFiscal={acaoFiscal}
          associadoOsExcluido={associadoOsExcluido}
          sqAlteracaoExecutorOs={sqAlteracaoExecutorOs}
        />
      </div>{" "}
      <ListaExecutoresAssociadosInclusao
        formik={formik}
        sqAltExec={sqAlteracaoExecutor}
        acaoFiscal={acaoFiscal}
        alteracaoExecutor={alteracaoExecutor}
        ehAlteracaoExecutor={ehAlteracaoExecutor}
        quantidadeIncluidosOs={quantidadeIncluidosOs}
      />{" "}
      <ListaExecutoresAssociadosExclusao
        formik={formik}
        sqAltExec={sqAlteracaoExecutor}
        acaoFiscal={acaoFiscal}
        alteracaoExecutor={alteracaoExecutor}
        associadoExcluido={associadoExcluido}
        quantidadeExcluidosOs={quantidadeExcluidosOs}
        fgLimpar={fgLimpar}
        fgLimparOs={fgLimparOs}
      />{" "}
      <div className="row">
        <div className="col-lg-12">
          <div className="card shadow mb-4">
            <div className="card-header pt-3 pb-3 flex-row w-100">
              <Form.Group as={Row} className="d-flex flex-row">
                <h6 className="font-weight-bold text-primary flex-grow-1 ml-2 mt-2"> </h6>

                {!showAdvancedSearch && (
                  <ButtonGroup>
                    <Form.Control
                      className="w-auto border-top-right-0 border-bottom-right-0"
                      type="text"
                      placeholder="Digite o nome"
                      value={inputSearchArgument}
                      onChange={(e) => setInputSearchArgument(e.target.value)}
                    />
                    <Button
                      className="btn-search-inside btn-md mr-3"
                      onClick={() => {
                        setPageNumber(1);
                        setSearchParameters({ searchArgument: inputSearchArgument });
                      }}
                    >
                      <FaSearch />
                    </Button>
                  </ButtonGroup>
                )}

                {formik && (
                  <Button
                    className="btn btn-primary btn-md mr-2"
                    tootip="Busca Avançada"
                    onClick={() => {
                      setShowAdvancedSearch((curr) => {
                        formik.resetForm();
                        return !curr;
                      });
                    }}
                  >
                    {showAdvancedSearch ? <RiFilterOffLine /> : <RiFilterLine />}
                  </Button>
                )}
              </Form.Group>

              {showAdvancedSearch && (
                <>
                  <hr />
                  <div>
                    <Row>
                      <Form>
                        <Form.Group as={Col} sm={12} md={6}>
                          <Form.Label>Setor</Form.Label>
                          <SelectInputCachedFormik
                            formik={formik}
                            field="sequencialOrgao"
                            tipoItem="orgaos-geral-os"
                            className="mb-3"
                          />
                        </Form.Group>
                      </Form>
                      <Form>
                        <Form.Group as={Col} sm={12} md={6}>
                          <Form.Label>Nome Executor</Form.Label>
                          <TextInputFormik formik={formik} field="nomeFormal" />
                        </Form.Group>
                      </Form>
                    </Row>
                    <Form.Group as={Row} className="pt-3">
                      <Col sm="12">
                        <Button
                          className="btn btn-primary btn-md mr-2"
                          onClick={() => {
                            setPageNumber(1);
                            setSearchParameters({ ...formik.values });
                          }}
                        >
                          Buscar
                        </Button>
                      </Col>
                    </Form.Group>
                  </div>
                </>
              )}

              <Form.Label className="small float-left pt-3">
                {`Total selecionado: ${propsFormik.values[field] ? propsFormik.values[field].length : 0}`}
              </Form.Label>
              <br />
              <br />
              <Form.Label className="float-left text-danger small">
                {propsFormik.errors[field] ? propsFormik.errors[field] : ""}
              </Form.Label>
            </div>

            <div className="card-body">
              <DataTable
                noHeader
                keyField="codigoExecutor"
                columns={columns}
                data={rows}
                progressPending={isLoading}
                noDataComponent="Nenhum registro para exibir"
                progressComponent={<TextSpinner />}
                defaultSortFieldId={1}
                sortIcon={<BsArrowDown />}
                pagination
                sortable
                paginationTotalRows={totalRows}
                selectableRows
                onSelectedRowsChange={(state) => {
                  updateFormik(state);
                }}
                pointerOnHover
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                paginationComponentOptions={constants.paginationComponentOptions}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListaAlteracaoExecutor;
